<template lang="html">
  <v-speed-dial left bottom direction="top" transition="slide-y-reverse-transition" fixed class="__menu-fixed">
    <template v-slot:activator>
      <v-btn fab large color="primary" :ripple="false" class="text-capitalize __menu-product" @click="show">
        <img src="@/assets/images/svg/book.svg" class="img-menu-book">
        Menu
      </v-btn>
      <v-menu v-model="showMenu" transition="scale-transition" origin="bottom left" content-class="__listmenu" max-height="350" :nudge-width="250" :close-on-click="closeOnClick" attach>
        <div id="list-menu" style="max-height: 350px; overflow-y: scroll;">
          <v-list v-scroll:#list-menu="onBottom">
            <v-list-item v-if="showCombo" @click="goToCombo()">
              <v-list-item-title>Combo</v-list-item-title>
            </v-list-item>
            <template v-for="(item, idx) in productGroup">
              <v-list-item v-if="item.total_product !== 0" :key="idx + '-item'" @click="goTo(item.id)">
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item>
              <template v-if="item.children">
                <template v-for="child in item.children">
                  <v-list-item v-if="child.products && child.products.length !== 0" :key="child.id + '-child'" @click="goTo(item.id)">
                    <v-list-item-title>{{ child.name }}</v-list-item-title>
                  </v-list-item>
                </template>
              </template>
            </template>
          </v-list>
        </div>
      </v-menu>
    </template>
  </v-speed-dial>
</template>

<script>
import {
  getProductGroup as getProductGroupList
} from '@/api/product'
export default {
  name: 'MenuProduct',
  props: {
    showCombo: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({
    closeOnClick: false,
    showMenu: false,
    productGroup: [],
    stopScroll: false,
    paramsMenu: {
      page: 1,
      per_page: 20
    },
    options: {
      duration: 300,
      offset: 0,
      easing: 'easeInOutCubic'
    }
  }),
  created: function() {
    this.loadGroupProductMenu()
  },
  methods: {
    onBottom(e) {
      const bottom = Math.round(e.target.scrollTop + e.target.offsetHeight) === e.target.scrollHeight
      if (bottom && this.stopScroll !== true) {
        this.loadGroupProductMenu()
      }
    },
    show() {
      if (this.productGroup.length !== 0) {
        this.showMenu = !this.showMenu
      }
    },
    async loadGroupProductMenu() {
      try {
        const params = {
          page: this.paramsMenu.page++,
          per_page: this.paramsMenu.per_page,
          search_column: 'total_product',
          search_operator: '>',
          search_text: '0',
          show_children: 0,
          show_product: 0
        }
        const { data } = await getProductGroupList(params)
        if (data.data.length === 0) {
          this.stopScroll = true
        } else {
          this.stopScroll = false
        }
        this.$store.state.loading_axios = false
        for (var i in data.data) {
          this.productGroup.push(data.data[i])
        }
      } catch (e) {
        this.productGroup = []
      }
    },
    goTo(id) {
      if (this.$store.state.selected_type === 'RESERVATION') {
        this.$router.push({ name: 'reservation_menu_group', params: { id: id }}).catch(() => {})
      } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        this.$router.push({ name: 'take_away_menu_group', params: { id: id }}).catch(() => {})
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        this.$router.push({ name: 'delivery_menu_group', params: { id: id }}).catch(() => {})
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        this.$router.push({ name: 'dinein_menu_group', params: { id: id }}).catch(() => {})
      }
    },
    goToCombo() {
      if (this.$store.state.selected_type === 'RESERVATION') {
        if (this.$router.currentRoute.name === 'reservation_menu') {
          this.$vuetify.goTo('#combo_product', this.options)
        } else {
          this.$router.push({ name: 'reservation_menu' }).catch(() => {})
        }
      } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        if (this.$router.currentRoute.name === 'take_away_menu') {
          this.$vuetify.goTo('#combo_product', this.options)
        } else {
          this.$router.push({ name: 'take_away_menu' }).catch(() => {})
        }
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        if (this.$router.currentRoute.name === 'delivery_menu') {
          this.$vuetify.goTo('#combo_product', this.options)
        } else {
          this.$router.push({ name: 'delivery_menu' }).catch(() => {})
        }
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        if (this.$router.currentRoute.name === 'dinein_menu') {
          this.$vuetify.goTo('#combo_product', this.options)
        } else {
          this.$router.push({ name: 'dinein_menu' }).catch(() => {})
        }
      }
    }
  }
}
</script>
